import React, { useEffect, useRef, useState } from 'react'
import ReactModal from 'react-modal'
import { FaTimes } from 'react-icons/fa'
import { ReactComponent as CloseModalIcon } from '../../assets/svg/CloseModalIcon.svg'
import { useTranslation } from 'react-i18next'
import { ANALYTICS_EVENTS } from '../../analytics/events'
import useTrackedSurface from '../../analytics/useTrackedSurface'

function VideoModal({ video, index, modalIsOpen, closeModal }) {
    const { t, locale } = useTranslation()

    const videoRef = useRef(null)
    const [loading, setLoading] = useState(true)
    useTrackedSurface(ANALYTICS_EVENTS.VIDEOS_VIDEO_VIEWED, {
        active: modalIsOpen,
        contentId: video?.id || video?.key || index,
        content: video?.title,
    })

    useEffect(() => {
        if (modalIsOpen) {
            ReactModal.setAppElement('#root')
            document.getElementById('home').style.filter = 'blur(5px)'
            if (videoRef.current) {
                videoRef.current.focus()
            }
        } else {
            document.getElementById('home').style.filter = 'unset'
        }
    }, [modalIsOpen])

    // Keyboard accessibility: ESC to close
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'Escape' && modalIsOpen) {
                closeModal()
            }
        }
        window.addEventListener('keydown', handleKeyDown)
        return () => window.removeEventListener('keydown', handleKeyDown)
    }, [modalIsOpen, closeModal])

    const handleLoadedData = () => setLoading(false)

    return (
        <ReactModal
            isOpen={modalIsOpen}
            onRequestClose={closeModal}
            style={{
                overlay: {
                    // backgroundColor: '#00000065',
                    zIndex: 10,
                },
                content: {
                    width: '80vw',
                    minHeight: 630,
                    padding: 0,
                    minWidth: 900,
                    backgroundColor: 'transparent',
                    border: 'none',
                    margin: 'auto',
                    boxShadow: 'none',
                },
            }}
        >
            <div
                style={{
                    position: 'absolute',
                    top: 0,
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 12,
                }}
            >
                <div className="logout-modal-icon" onClick={() => closeModal()}>
                    <CloseModalIcon />
                </div>
            </div>
            <div
                style={{
                    minWidth: 900,
                    // width: '80vw',
                    minHeight: '70vh',
                    height: '100%',
                    maxHeight: '80vh',
                    // maxHeight: '80vh',
                    padding: 0,
                    opacity: 1,
                    background: '#d7e2f8',
                    display: 'flex',
                    flexDirection: 'column',
                    marginTop: 30,
                    marginBottom: 30,
                    borderRadius: 10,
                    overflow: 'hidden',
                }}
            >
                <div className="video-widget-header video-play-card bg-[#ECEBF8] !mt-0">
                    <p className="!text-[#ECEBF8]">{video.title}</p>
                </div>
                <div
                    style={{
                        flex: 1,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        background: '#d7e2f8',
                        position: 'relative',
                        padding: '10%',
                        overflow: 'hidden', // ensures no overflow
                    }}
                >
                    {loading && (
                        <div
                            style={{
                                position: 'absolute',
                                left: '50%',
                                top: '50%',
                                transform: 'translate(-50%, -50%)',
                                zIndex: 2,
                            }}
                        >
                            <div
                                className="spinner"
                                style={{
                                    border: '4px solid #ECEBF8',
                                    borderTop: '4px solid #595f90',
                                    borderRadius: '50%',
                                    width: 40,
                                    height: 40,
                                    animation: 'spin 1s linear infinite',
                                }}
                            />
                        </div>
                    )}
                    <video
                        ref={videoRef}
                        controls
                        controlsList="nodownload"
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'contain',
                            borderRadius: 12,
                            boxShadow: '0 2px 12px rgba(94,99,155,0.10)',
                            background: '#ECEBF8',
                        }}
                        autoPlay
                        tabIndex={0}
                        onLoadedData={handleLoadedData}
                        aria-label={video.title}
                    >
                        <source src={video.src} />
                        {t('yourBrowserDoesNotSupportHTMLVideo')}
                    </video>
                </div>
            </div>
            <style>{`
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
            `}</style>
        </ReactModal>
    )
}

export default VideoModal
